import React, { useEffect, useContext } from 'react'
import { Skeleton } from 'antd'
import PurchasePlanAndCredits from './PurchasePlanAndCredits/PurchasePlanAndCreditsV2'
import { useSelector, useDispatch } from 'react-redux'
import {
  setCheckoutModalOpen,
  setDefaultWorkflowNode,
  clearCheckoutPendingResultNode
} from 'src/actions/stripeCheckout'
import { fetchUserGQ } from 'src/actions/user'
import styles from './stripe-checkout-container.scss'
import cn from 'classnames'
import HobnobModal from 'src/components/common/HobnobModalV2/HobnobModal'
import { PageContainerContext } from 'services/contexts'
import { userSelector, stripeCheckoutSelector, userLoadingSelector } from 'src/selectors'

const StripeCheckoutContainer = () => {
  const userInfo = useSelector(userSelector) || {}
  const checkoutContext = useSelector(stripeCheckoutSelector)
  const userLoading = useSelector(userLoadingSelector)
  const isCheckoutModalVisible = checkoutContext.isCheckoutModalOpen

  const dispatch = useDispatch()
  const context = useContext(PageContainerContext)

  useEffect(() => {
    dispatch(fetchUserGQ())
  }, [])

  useEffect(() => {
    if (isCheckoutModalVisible) {
      const handleStorageCallback = data => {
        if (data?.hasError && checkoutContext.checkoutPendingResultNode) {
          dispatch(setDefaultWorkflowNode(checkoutContext.checkoutPendingResultNode))
          dispatch(setCheckoutModalOpen(true))
        } else if (data && !data?.hasError && (data.planUpdated || data.creditsUpdated)) {
          handleCloseModal()
        }
        dispatch(clearCheckoutPendingResultNode())
      }

      context.onSetStorageCallback(handleStorageCallback)
    }

    return () => {
      context.onSetStorageCallback(null)
    }
  }, [isCheckoutModalVisible])

  const handleCloseModal = () => {
    dispatch(setCheckoutModalOpen(false))
  }

  return (
    <HobnobModal
      visible={isCheckoutModalVisible}
      onCancel={handleCloseModal}
      destroyOnClose
      maskClosable={false}
    >
      {userLoading && (
        <div className={styles['skeleton-container']}>
          <Skeleton active avatar title paragraph={{ rows: 10 }} />
        </div>
      )}
      <div className={cn(styles['context-container'], { [styles['hide']]: userInfo.isLoading })}>
        <PurchasePlanAndCredits onClose={handleCloseModal} />
      </div>
    </HobnobModal>
  )
}

export default StripeCheckoutContainer
